module.exports = __webpack_public_path__ + "static/october-3-c491b3c412809ed3f8479df693d5faf9.png";